import React, { useEffect, useRef, useState } from "react";
import "./AnnouncementTypes.scss";
import LockIcon2 from "../../../../components/icons/LockIcon2";
import RoundTrueIcon from "../../../../components/icons/RoundTrueIcon";
import { useDispatch } from "react-redux";
import ProtectedComponent from "../../../../components/ProtectedComponent";
import NavigationLayout from "../../navigation";
import BackArrowIcon from "../../../../components/icons/BackArrowIcon";
import { clientRoutes } from "../../../../utils/routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CommonEnums } from "../../../../enums/common.enums";
import AnnouncementSelectionTemplate from "./AnnouncementSelectionTemplate";
import { TemplatesApi } from "../../../../utils/api/Templates";
import Loading from "../../../loading/Loading";

const AnnouncementTypes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  let type: any = searchParams?.get("type");
  let subscription_type: any = searchParams?.get("subscription_type");
  let listing_type: any = searchParams?.get("listing_type");
  const [configuredTypes, setConfiguredTypes] = useState<string[]>([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [isLoadingConfigs, setIsLoadingConfigs] = useState(true);

  const announcementTypes = [
    { slug: "hiring", label: "Hiring" },
    { slug: "work_anniversary", label: "Work Anniversary" },
    { slug: "birthday", label: "Birthday" },
    { slug: "events", label: "Events" },
    {
      slug: "transaction_success_showcase",
      label: "Transaction success showcase",
    },
    { slug: "office_holiday", label: "Office Closure / Holiday" },
    { slug: "awards", label: "Awards / Recognition" },
    { slug: "promotions", label: "Promotions / Role Changes" },
    { slug: "office_relocation", label: "Office Relocation / New Branch" },
  ];

  const handleSelectAnnouncement = (announcementItem: any) => {
    setSelectedAnnouncement(announcementItem);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedAnnouncement(null);
    fetchConfiguredTemplates();
  };

  const isConfiguredForSubtype = (slug: string) => false;

  const fetchConfiguredTemplates = async () => {
    setIsLoadingConfigs(true);
    try {
      const promises = announcementTypes.map(async (item) => {
        const response = await TemplatesApi.getAgencyAnnouncementTemplates({
          announcement_type: item.slug,
        });

        if (response.success && response.data?.data) {
          const hasAnyConfig = Object.values(response.data.data).some(
            (postType: any) =>
              postType?.templates?.some((template: any) =>
                template.config?.some((c: any) => c.status === "active")
              )
          );

          return hasAnyConfig ? item.slug : null;
        }
        return null;
      });

      const results = await Promise.all(promises);
      setConfiguredTypes(
        results.filter((slug): slug is string => slug !== null)
      );
    } finally {
      setIsLoadingConfigs(false);
    }
  };

  useEffect(() => {
    fetchConfiguredTemplates();
  }, []);

  return (
    <ProtectedComponent>
      <NavigationLayout>
        <div className="announcement-property-stage-container">
          <div
            className="propertie-view-back-btn"
            onClick={() => navigate(clientRoutes.designTemplates)}
          >
            <div className="back-icon">
              <BackArrowIcon />
            </div>
            <p className="bakc-text-contain">Back to Template Configuration</p>
          </div>
          <div className="design-templates-heading">
            <p>Configuring Design Templates</p>
            <div className="design-templates-header">
              <div className="template-config-meta">
                <div className="meta-item">
                  <p className="label">Subscription Type</p>
                  <p className="value">
                    {subscription_type
                      ?.replace(/_/g, " ")
                      .replace(/\b\w/g, (char: string) => char.toUpperCase())}
                  </p>
                </div>
                <div className="meta-item">
                  <p className="label">Listing Type</p>
                  <p className="value">
                    For{" "}
                    {listing_type
                      ?.replace(/_/g, " ")
                      .replace(/\b\w/g, (char: string) => char.toUpperCase())}
                  </p>
                </div>
                <div className="meta-item">
                  <p className="label">Templates For</p>
                  <p className="value">Announcement Post</p>
                </div>
              </div>
            </div>
          </div>
          <div className="property-stage-top-head">
            <p>Announcement Types</p>
          </div>
          <div className="property-stage-sub-head">
            <p>
              Select announcement type to continue design templates selection
            </p>
          </div>

          <div className="property-stage-two announcement-stage-contain">
            {announcementTypes.map((item) => {
              const isConfigured = configuredTypes.includes(item.slug);
              return (
                <div key={item.slug}>
                  <button
                    className={`property-stage-box`}
                    onClick={() => handleSelectAnnouncement(item)}
                  >
                    <div className="proprty-title">
                      <div className="proprty-title-and-lock-icon">
                        <div className="lock-icon">
                          <LockIcon2 />
                        </div>
                        {item.slug === "awards" ? (
                          <p
                            className="proprty-title-text"
                            dangerouslySetInnerHTML={{
                              __html: "Awards /<br />Recognition",
                            }}
                          />
                        ) : (
                          <p className="proprty-title-text">{item.label}</p>
                        )}
                      </div>
                    </div>
                    <div className="pending-message">
                      {isLoadingConfigs ? (
                        <p className="loading-text">
                          <Loading />
                        </p>
                      ) : isConfigured ? (
                        <>
                          <RoundTrueIcon />
                          <p>Configured</p>
                        </>
                      ) : (
                        <>
                          <img
                            src="/images/HistoryTemplate.svg"
                            alt="Pending Icon"
                            className="pending-icon"
                          />
                          <p>
                            Template Selection Is <br /> Pending
                          </p>
                          <p className="select-template">Select Template</p>
                        </>
                      )}
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {selectedAnnouncement && (
          <AnnouncementSelectionTemplate
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            announcementType={selectedAnnouncement}
          />
        )}
      </NavigationLayout>
    </ProtectedComponent>
  );
};

export default AnnouncementTypes;
